module.exports = "/assets/data/c1d7fc04282aa52b600160650dce036f-NP23.data.json";